/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ClinicRequestContentUserProgression } from "./ClinicRequestContentUserProgression";

export interface ClinicRequestContent {
  user_progression?: ClinicRequestContentUserProgression;
  type?: string | null;
  archived?: boolean;
}
